import { c as _c } from "react/compiler-runtime";
import { IconButton } from "@/components/ui/buttons";
import { getTranslations, type Locale } from "@/lib/i18n/config";
interface AgentHeaderProps {
  onNewSession?: () => void;
  onClose?: () => void;
  locale?: Locale;
}
export const AgentHeader: React.FC<AgentHeaderProps> = t0 => {
  const $ = _c(16);
  const {
    onNewSession,
    onClose,
    locale: t1
  } = t0;
  const locale = t1 === undefined ? "de" : t1;
  let t2;
  if ($[0] !== locale) {
    t2 = getTranslations(locale);
    $[0] = locale;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    agent: t
  } = t2;
  let t3;
  if ($[2] !== t.panelTitle) {
    t3 = <h2 id="agent-panel-title" className="bg-black/40 backdrop-blur-xl px-4 py-2 rounded-lg">{t.panelTitle}</h2>;
    $[2] = t.panelTitle;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onNewSession || $[5] !== t.newSession.start) {
    t4 = <IconButton icon="agent-new-session" color="dark" onClick={onNewSession} ariaLabel={t.newSession.start} />;
    $[4] = onNewSession;
    $[5] = t.newSession.start;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onClose || $[8] !== t.closeAssistant) {
    t5 = <IconButton icon="agent-minimize" color="dark" onClick={onClose} ariaLabel={t.closeAssistant} />;
    $[7] = onClose;
    $[8] = t.closeAssistant;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex gap-2">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <section className="flex items-center justify-between gap-2 py-2 px-5 pt-5">{t3}{t6}</section>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};